/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'
import * as http from '@core/http'
let baseMark = process.env.NODE_ENV === 'production' ? '' : ''

/**
 * 获取菜单
 *
 * @export
 * @returns
 */
export function getMenus() {
    return httpAgent.GET(`${baseMark}/popadmin/admin/getMenuList`)
  }


/**
 * 集易推重定向
 *
 * @export
 * @returns
 */
export function redirect() {
  return  http.GET(`/popadmin/admin/supplierEnter/unionJiYiTui/redirect`)
}

/**
 * 供应链金融助力计划
 *
 * @export
 * @returns
 */
export function unionFinanceRedirect() {
  return  http.GET(`/popadmin/admin/supplierEnter/unionFinance/redirect`)
}